import { render, staticRenderFns } from "./RenewalInplayDetail2.vue?vue&type=template&id=57b5c55a&scoped=true"
import script from "./RenewalInplayDetail2.vue?vue&type=script&lang=js"
export * from "./RenewalInplayDetail2.vue?vue&type=script&lang=js"
import style0 from "./RenewalInplayDetail2.vue?vue&type=style&index=0&id=57b5c55a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b5c55a",
  null
  
)

export default component.exports